module.exports = __webpack_public_path__ + "img/visa.7caea87d.svg";